import React, { Component } from 'react'
import Dialog from '@material-ui/core/Dialog';
import Icon from '@material-ui/core/Icon'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { shouldShowCompliant, getCarryOverReasons, getCarryOverInfo, LBS_PER_KG } from '../../../util'
import _ from 'lodash'
import Transition from '../../../../../../../images/modals/check-in-transition.svg'
import IconCalendar from '../../../../../../../images/modals/iconCalendar.png'
import MacroGraph from '../../average-graph/macro-graph'
import MacroAdjustmentGraph from './adjustment-graph'
import { editWeighIn } from "../../../../../../../api";

function validateWeight(weight, useMetric) {
  const inMetricRange = (weight <= 453.592 && weight >= 31.75)
  const inImperialRange = (weight <= 999 && weight >= 70)
  const isUsingMetric = (Number(useMetric) === 1)
  if (!(/^([0-9,.]{0,3})\d/.test(weight)) || ((isUsingMetric) ? !inMetricRange : !inImperialRange) || !weight || weight.length > 8)
    return 'Invalid weight'
}

function validateBodyFat(bodyFat, gender) {
  const inRangeMale = (Number(bodyFat) >= 3 && Number(bodyFat) <= 60)
  const inRangeFemale = (Number(bodyFat) >= 8 && Number(bodyFat) <= 65)

  if ((!inRangeMale && gender === 'MALE') || (!inRangeFemale && gender === 'FEMALE') || bodyFat.length > 5)
    return 'Invalid body fat percentage'
}

class EditWeighInModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEdit: false,
      showCompliant: true,
      showMenstrual: false,
      weight: '',
      body_fat: '',
      weightId: '',
      weightError: '',
      bodyFatError: '',
      bodyfatId: '',
      reportDate: '',
      isCompliant: '',
      estimatedWeight: '',
      shouldIgnoreWeightGain: '',
      isNearPeriod: '',
      isRetainingFluid: '',
      keep: null,
      reasonCode: null,
      reasonText: null,
      isSubmitting: false,
      response: '',
      showSnackbar: false
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(!_.isEmpty(this.props.weighins) && (this.props.open === false && nextProps.open === true)) {
      let avgProtein = 0
      let avgCarbs = 0
      let avgFat = 0
      
      if(nextProps.timeline.user !== undefined) {
        avgProtein = nextProps.timeline.user.avgProtein
        avgCarbs = nextProps.timeline.user.avgCarbs
        avgFat = nextProps.timeline.user.avgFat
      }
  
      let compareProtein = avgProtein < (Number(this.props.protein) + this.getProteinInterval(this.props.protein)) && avgProtein >= (this.props.protein - this.getProteinInterval(this.props.protein))
      let compareCarbs = avgCarbs < (Number(this.props.carbs) + this.getCarbsInterval(this.props.carbs)) && avgCarbs >= (this.props.carbs - this.getCarbsInterval(this.props.carbs))
      let compareFat = avgFat < (Number(this.props.fat) + this.getFatInterval(this.props.fat)) && avgFat >= (this.props.fat - this.getFatInterval(this.props.fat))
      this.checkIfCompliant(compareProtein, compareCarbs, compareFat)

      const weighin = nextProps.weighins[nextProps.selectedWeighInIndex]
      const showMenstrual = (this.props.gender === 'FEMALE' && this.props.skipNearPeriod !== 1)
      const prevWeighIn = nextProps.weighins[nextProps.selectedWeighInIndex + 1];
      const showCompliant = shouldShowCompliant(nextProps.startingPoint, weighin, prevWeighIn, nextProps.weighins, nextProps.selectedWeighInIndex)
      // let showEstimateWeight = shouldEstimateWeight('EditWeight', weighin, nextProps.goal, nextProps.goalLevel);
      let estimatedWeight = null;

      if(weighin.estimated_weight) {
        // showEstimateWeight = true
        estimatedWeight = Math.round(((this.props.useMetricUnits) ? weighin.estimated_weight :  weighin.estimated_weight * LBS_PER_KG)* 10) / 10;
      }

      this.setState({
        showCompliant: showCompliant,
        showMenstrual: showMenstrual,
        reportDate: weighin.report_date,
        weightId: weighin.weight_id,
        estimatedWeight: estimatedWeight,
        // showEstimateWeight: showEstimateWeight,
        bodyfatId: weighin.bodyfat_id,
        weight: Math.round(((this.props.useMetricUnits) ? weighin.weight :  weighin.weight * LBS_PER_KG) * 10) / 10,
        body_fat: weighin.body_fat,
        keep: null,
        reasonCode: null,
        reasonText: null,
        shouldIgnoreWeightGain: weighin.near_period,
        isNearPeriod: weighin.near_period,
        isRetainingFluid: weighin.near_period,
        isCompliant: weighin.compliant,
        isSubmitting: false
      })
    }
  }

  handleRequestClose = () => {
      this.setState({ showSnackbar: false });
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  }

  handleReasonTextChange = (e) => {
    this.setState({reasonText: e.target.value});
  }

  handleClear = () => {
    this.setState({ keep: null, reasonCode: null, reasonText: null })
  }

  handleClose = () => {
    this.props.showEditWeighInModal(false, this.props.selectedWeighInIndex)
  }

  getEffectiveNearPeriod = () => {
    return this.state.showMenstrual && this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && (this.state.isCompliant !== 1 || this.state.shouldIgnoreWeightGain === 1)
  }

  handleSubmit = (e) => {
    const wError = validateWeight(this.state.weight, this.props.useMetricUnits);
    const bfError = validateBodyFat(this.state.body_fat, this.props.gender);
    const oldWeight = this.props.weighins[this.props.selectedWeighInIndex].weight
    let editedWeight = Number(this.state.weight)
    let estimatedWeight = (this.state.estimatedWeight) ? Number(this.state.estimatedWeight) : null

    if(wError) {
      this.props.openFeedback('Invalid weight', true)
      return
    } else if (bfError) {
      this.props.openFeedback('Invalid body fat percentage', true)
      return
    }

    // if(wError || bfError) {
    //   this.setState({ weightError: wError, bfError: bfError });
    //   return;
    // }

    if(!Number(this.props.useMetricUnits))
      editedWeight = editedWeight / LBS_PER_KG

    editedWeight = (Math.round(oldWeight * 100) / 100 === Math.round(editedWeight * 100) / 100) ? oldWeight : editedWeight;

    if(this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && (this.state.isCompliant !== 1 || this.state.shouldIgnoreWeightGain === 1) && !estimatedWeight) {
      this.props.openFeedback('Please enter an estimated weight', true)
      return;
    }

    if(estimatedWeight && !Number(this.props.useMetricUnits))
      estimatedWeight = estimatedWeight / LBS_PER_KG

    const request = {
      action: 'Edit',
      edits: {
        weight: editedWeight,
        estimated_weight: estimatedWeight,
        body_fat: Number(this.state.body_fat),
        weight_id: this.state.weightId,
        bodyfat_id: this.state.bodyfatId,
        report_date: this.props.weighins[this.props.selectedWeighInIndex].report_date.split('T')[0]
      },
      user_id: this.props.userId,
      portal_id: this.props.portalId
    }

    if(this.state.showCompliant)
      request['edits']['compliant'] = this.state.isCompliant

    const effectiveNearPeriod = this.getEffectiveNearPeriod()

    if(this.props.potentiallyKeepable) {
      let carryOverInfo = {keepable: false}
      if(this.state.isCompliant) {
        carryOverInfo = getCarryOverInfo(request.edits.weight, request.edits.body_fat, effectiveNearPeriod, this.props.carryOverEnvironment, this.props.user)
      }
      if(!carryOverInfo.keepable) {
        if(this.props.weighins[this.props.selectedWeighInIndex].keep !== null) {
          request['edits']['adjustment_hidden'] = true
        }
      } else {
        if(this.state.keep !== null && this.state.keep !== this.props.keep) {
          request['edits']['keep'] = this.state.keep
        }
        let reasonCode = this.state.reasonCode === null ? this.props.reasonCode : this.state.reasonCode
        const reasonText = this.state.reasonText === null ? this.props.reasonText : this.state.reasonText
        if(reasonCode !== this.props.reasonCode) {
          request['edits']['reason_code'] = reasonCode
        }
        if(reasonText !== this.props.reasonText) {
          request['edits']['reason_text'] = reasonText
        }
      }
    }

    if(this.state.showMenstrual)
      request['edits']['near_period'] = effectiveNearPeriod ? 1 : 0

    this.setState({ isSubmitting: true })
    editWeighIn(request)
      .then(() => {
          this.props.openFeedback('Check-in has been edited', false)
          this.props.loadPortalAccount();
          this.props.onClose();
          this.setState({ isSubmitting: false })
      }).catch((err) => {
        this.props.openFeedback('Check-in encountered an error', true)
        this.setState({ isSubmitting: false })
      });
  }

  renderCompliant = () => {
    let avgProteinConsumed = 0
    let avgCarbsConsumed = 0
    let avgFatConsumed = 0
    let avgProteinTarget = 0
    let avgCarbsTarget = 0
    let avgFatTarget = 0
    
    const checkinDate = this.props.weighins[this.props.selectedWeighInIndex].report_date.split('T')[0]
    const checkinMacroData = this.props.macroData.weighInDetails[checkinDate].result

    if (checkinMacroData) {
      avgProteinConsumed = checkinMacroData.avgProtein.toFixed()
      avgCarbsConsumed = checkinMacroData.avgCarbs.toFixed()
      avgFatConsumed = checkinMacroData.avgFat.toFixed()
      avgProteinTarget = checkinMacroData.avgTargetProtein.toFixed()
      avgCarbsTarget = checkinMacroData.avgTargetCarbs.toFixed()
      avgFatTarget = checkinMacroData.avgTargetFat.toFixed()
    } else {
      this.props.getMacroData(checkinDate)
    }
    
    return (
      <>
        <h4 className="content-header">Tracked averages</h4>
        <label>Were you in range of your target macros since last check-in?</label>
        <MacroGraph
          proteinConsumed={Math.round(avgProteinConsumed)}
          carbsConsumed={Math.round(avgCarbsConsumed)}
          fatConsumed={Math.round(avgFatConsumed)}
          proteinTarget={Math.round(avgProteinTarget)}
          carbsTarget={Math.round(avgCarbsTarget)}
          fatTarget={Math.round(avgFatTarget)}
          vacationMode={this.props.user.vacation_mode}
          showConsumedMacros
          showUnderRange
          light
        />
        <div className='check-in-button-group'>
          <button className={(this.state.isCompliant === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({isCompliant: 1})}>Yes</button>
          <button className={(this.state.isCompliant === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({isCompliant: 0})}>No</button>
        </div>
      </>
    )
  }

  renderAdjustment = (carryOverInfo) => {
    const keep = this.state.keep !== null ? this.state.keep : this.props.keep
    const reasonCode = this.state.reasonCode === null ? this.props.reasonCode : this.state.reasonCode
    const reasonText = this.state.reasonText === null ? this.props.reasonText : this.state.reasonText
    const newProteinRounded = carryOverInfo.macros.new.protein
    const newCarbsRounded = carryOverInfo.macros.new.carbs
    const newFatRounded = carryOverInfo.macros.new.fat
    const oldProteinRounded = carryOverInfo.macros.old.protein
    const oldCarbsRounded = carryOverInfo.macros.old.carbs
    const oldFatRounded = carryOverInfo.macros.old.fat
    let carryOverQuestion = 'Would you like to accept your new macros or keep your old macros?'
    return (
      <>
        <h4 className="content-header">Macro Adjustment</h4>
        <label>{carryOverQuestion}</label>
        <MacroAdjustmentGraph 
          proteinValue={(keep === 1) ? oldProteinRounded : newProteinRounded}
          carbsValue={(keep === 1) ? oldCarbsRounded : newCarbsRounded}
          fatValue={(keep === 1) ? oldFatRounded : newFatRounded}
        />
        <div className='check-in-button-group'>
          <button className={(keep === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ keep: 1 })}>Keep Targets</button>
          <button className={(keep === 0) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ keep: 0 })}>Accept Adjustment</button>
        </div>
        {keep === 1 && this.props.user.skip_carry_over_reason === 0 &&
          <>
            <label>Okay. Why would you like to keep your targets? (you can select more than one reason)</label>
            <List>
              {getCarryOverReasons(this.props.weighins[this.props.selectedWeighInIndex].goal).map((reason, index) => (reason[0] & carryOverInfo.reasonsMask) !== 0 &&
                <ListItem key={reason[0]}>
                  <Icon className='material-icons' id={'carry-over-reason-checkbox-' + reason[0]} onClick={() => this.setState({reasonCode: reasonCode ^ reason[0]})} style={{ color: (reasonCode & reason[0]) ? '#14ab40' : '#5a5a5a'}}>
                    {(reasonCode & reason[0]) ? 'check_circle' : 'radio_button_unchecked'}
                  </Icon>
                  <span className='carry-over-reason-text'>{reason[1]}</span>
                </ListItem>
              )}
            </List>
            <p className="carry-over-reason-label">Other (optional):</p>
            <textarea className="carry-over-reason-other" name="" value={reasonText} onChange={this.handleReasonTextChange}></textarea>
          </>
        }

        {/* <div className='weigh-in-question'>
          <div className='weigh-in-question-container'>
            <h3>ADJUSTMENT</h3>
            <p>{carryOverQuestion}</p>
            <div className='weigh-in-compliant-buttons'>
              <button className={(keep === 0) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ keep: 0 })}>Accept Adjustment</button>
              <button className={(keep === 1) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ keep: 1 })}>Keep Targets</button>
            </div>
          </div>
          {keep === 1 && this.props.user.skip_carry_over_reason === 0 &&
            <div className='carry-over-reason-container'>
              <p>Okay. Why would you like to keep your targets? (you can select more than one reason)</p>
              <List>
                {getCarryOverReasons(this.props.weighins[this.props.selectedWeighInIndex].goal).map((reason, index) => (reason[0] & carryOverInfo.reasonsMask) !== 0 &&
                  <ListItem key={reason[0]}>
                    <Icon className='material-icons' id={'carry-over-reason-checkbox-' + reason[0]} onClick={() => this.setState({reasonCode: reasonCode ^ reason[0]})}>
                      {(reasonCode & reason[0]) ? 'check_box' : 'check_box_outline_blank'}
                    </Icon>
                    <span className='carry-over-reason-text'>{reason[1]}</span>
                  </ListItem>
                )}
              </List>
              <p>Other (optional):</p>
              <textarea className="carry-over-reason-other" name="" value={reasonText} onChange={this.handleReasonTextChange}></textarea>
            </div>
          }
        </div> */}
      </>
    )
  }

  renderMenstrual = () => {
    return (
      <>
        <h4 className="content-header">Menstrual cycle</h4>
        <label>Are you within 5 days of starting your period?</label>
        <div className='check-in-button-group'>
          <button className={(this.state.isNearPeriod === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({isNearPeriod: 1})}>Yes</button>
          <button className={(this.state.isNearPeriod === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({isNearPeriod: 0})}>No</button>
        </div>

        {this.state.isNearPeriod === 1 &&
          <>
            <label>Do you think that you may be retaining fluid weight?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.isRetainingFluid === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ isRetainingFluid: 1 })}>Yes</button>
              <button className={(this.state.isRetainingFluid === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ isRetainingFluid: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.isCompliant === 1 && this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && this.props.goal !== 'REVERSE DIETING') &&
          <>
            <label>Since your menstrual cycle may be artificially increasing your weight this week, we will not adjust your macros if you fell short of your goal. Is this okay?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 1 })}>Yes</button>
              <button className={(this.state.shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.isCompliant === 1 && this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && this.props.goal === 'REVERSE DIETING') &&
          <>
            <label>Since your menstrual cycle may be artificially increasing your weight this week, we will apply the typical adjustment to your macros even if you exceeded the limit defined by your goal. Is this okay?</label>
            <div className='check-in-button-group'>
              <button className={(this.state.shouldIgnoreWeightGain === 1) ? 'check-in-button-radio yes' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 1 })}>Yes</button>
              <button className={(this.state.shouldIgnoreWeightGain === 0) ? 'check-in-button-radio no' : 'check-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 0 })}>No</button>
            </div>
          </>
        }
        {(this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && this.state.isCompliant === 0) &&
          <>
            <label>Estimate your most recent weight that was not affected by your menstrual cycle:</label>
            <input name='estimatedWeight' value={this.state.estimatedWeight} onChange={this.handleChange}/>
            <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>
          </>
        }

        {/* <div className='weigh-in-question'>
          <div className='weigh-in-question-container'>
            <h3>MENSTRUAL CYCLE</h3>
            <p>Are you within 5 days of starting your period?</p>
            <div className='weigh-in-compliant-buttons'>
              <button className={(this.state.isNearPeriod === 1) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ isNearPeriod: 1 })}>Yes</button>
              <button className={(this.state.isNearPeriod === 0) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ isNearPeriod: 0 })}>No</button>
            </div>
          </div>
          {this.state.isNearPeriod === 1 &&
            <div className='weigh-in-question-container'>
              <p>Do you think that you may be retaining fluid weight?</p>
              <div className='weigh-in-compliant-buttons'>
                <button className={(this.state.isRetainingFluid === 1) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ isRetainingFluid: 1 })}>Yes</button>
                <button className={(this.state.isRetainingFluid === 0) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ isRetainingFluid: 0 })}>No</button>
              </div>
            </div>
          }
          {(this.state.isCompliant === 1 && this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && this.props.goal !== 'REVERSE DIETING') &&
            <div className='weigh-in-question-container'>
              <p>Since your menstrual cycle may be artificially increasing your weight this week, we will not adjust your macros if you fell short of your goal. Is this okay?</p>
              <div className='weigh-in-compliant-buttons'>
                <button className={(this.state.shouldIgnoreWeightGain === 1) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 1 })}>Yes</button>
                <button className={(this.state.shouldIgnoreWeightGain === 0) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 0 })}>No</button>
              </div>
            </div>
          }
          {(this.state.isCompliant === 1 && this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && this.props.goal === 'REVERSE DIETING') &&
            <div className='weigh-in-question-container'>
              <p>Since your menstrual cycle may be artificially increasing your weight this week, we will apply the typical adjustment to your macros even if you exceeded the limit defined by your goal. Is this okay?</p>
              <div className='weigh-in-compliant-buttons'>
                <button className={(this.state.shouldIgnoreWeightGain === 1) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 1 })}>Yes</button>
                <button className={(this.state.shouldIgnoreWeightGain === 0) ? 'weigh-in-button-radio-active' : 'weigh-in-button-radio'} onClick={() => this.setState({ shouldIgnoreWeightGain: 0 })}>No</button>
              </div>
            </div>
          }
          {(this.state.isNearPeriod === 1 && this.state.isRetainingFluid === 1 && (this.state.isCompliant !== 1 || this.state.shouldIgnoreWeightGain === 1) && this.state.showEstimateWeight) ?
            <div className='weigh-in-question-container'>
              <p>Estimate your most recent weight that was not affected by your menstrual cycle:</p>
              <div className='weigh-in-input-box'>
                <input name='estimatedWeight' type='number' value={this.state.estimatedWeight} onChange={this.handleChange}/>
                <div className='weigh-in-input-box-unit-container'>
                  <p>{this.props.useMetricUnits ? 'kg' : 'lbs'}</p>
                </div>
              </div>
            </div>
          : null}
        </div> */}
      </>
    )
  }

  checkIfCompliant = (compareProtein, compareFat, compareCarbs) => {
    if(compareProtein === true && compareFat === true && compareCarbs === true) {
      this.setState({ edit_isCompliant: 1 })
    }
  }

  getProteinInterval = (targetProtein) => {
    const proteinSlope = Math.round((1/30 * targetProtein) + (6.6666666667))
    if(targetProtein <= 100) {
      return 10
    }
    else if(targetProtein > 100 && targetProtein < 250) {
      return Math.round(proteinSlope)
    }
    else {
      return 15
    }
  }

  getCarbsInterval = (targetCarbs) => {
    const carbsSlope = Math.round((11/450 * targetCarbs) + (3.7777777778))
    if(targetCarbs <= 50) {
      return 5
    }
    else if(targetCarbs > 50 && targetCarbs < 500) {
      return Math.round(carbsSlope)
    }
    else {
      return 16
    }
  }

  getFatInterval = (targetFat) => {
    const fatSlope = Math.round((2/75 * targetFat) + (10/3))
    if(targetFat <= 75) {
      return 4
    }
    else if(targetFat > 75 && targetFat < 175) {
      return Math.round(fatSlope)
    }
    else {
      return 8
    }
  }

  getWeightString = () => {
    if(this.props.user && this.props.dailyWeights) {
      const userProps = this.props.user
      const weights = this.props.dailyWeights
      let prevWeightStr,
        prevWeight,
        prevWeightLocal,
        units;

      units = userProps.use_metric_units === 0 ? 'Pounds' : 'Kg';

      if (weights.length) {
        prevWeight = weights[0].weight;
      } else {
        prevWeight = userProps.weight;
      }
      const multiplier = userProps.use_metric_units === 0 ? LBS_PER_KG : 1;
    
      if (prevWeight) {
        prevWeightLocal = Math.round(prevWeight * multiplier, 2);
        prevWeightStr = prevWeightLocal + ' ' + units;
      }
      
      return prevWeightStr;
    }
  };
  
  render() {
    const reportDate = new Date(this.state.reportDate)
    const reportDateFormatted = new Date((reportDate.getUTCFullYear()),reportDate.getMonth(),reportDate.getUTCDate()).toDateString()
    let carryOverInfo = {keepable: false}
    if(this.props.potentiallyKeepable && this.state.isCompliant) {
      const wError = validateWeight(this.state.weight, this.props.useMetricUnits)
      const bfError = validateBodyFat(this.state.body_fat, this.props.gender)
      if(!(wError || bfError)) {
        const oldWeight = this.props.weighins[this.props.selectedWeighInIndex].weight
        let editedWeight = Number(this.state.weight)

        if(!Number(this.props.useMetricUnits))
          editedWeight = editedWeight / LBS_PER_KG

        editedWeight = (Math.round(oldWeight * 100) / 100 === Math.round(editedWeight * 100) / 100) ? oldWeight : editedWeight

        const editedBodyFat = Number(this.state.body_fat)
        carryOverInfo = getCarryOverInfo(editedWeight, editedBodyFat, this.getEffectiveNearPeriod(), this.props.carryOverEnvironment, this.props.user)
      }
    }

    return (
      <Dialog
        className='check-in-dialog' 
        fullScreen
        open={this.props.open}
        onClose={this.props.onClose}
        onExited={this.handleClear}
        autoScrollBodyContent={true}
      >
        <div className="check-in-close">
          <button onClick={this.props.onClose}>
            <Icon>close</Icon>
          </button>
        </div>
        <div className="check-in-dialog">
          <div className="check-in-header">
            <h3>Edit Check-in</h3>
            <img src={Transition} alt="wave" />
          </div>
          <div className="check-in-content">
            <div className="check-in-date">
              <img src={IconCalendar} alt="calendar" />
              <p>{reportDateFormatted}</p>
            </div>

            <h4 className="content-header">Weight</h4>
            <label>Previous weight: <span style={{color: '#14ab40'}}>{this.getWeightString()}</span></label>
            <input name='weight' type='number' value={this.state.weight} onChange={this.handleChange}/>
            <label>{this.props.useMetricUnits ? 'Kilograms' : 'Pounds'}</label>

            <h4 className="content-header">Body fat percentage</h4>
            <label>Previous body fat percentage: <span style={{color: '#14ab40'}}>{this.props.user.body_fat}%</span></label>
            <input name='body_fat' type='number' value={this.state.body_fat} onChange={this.handleChange}/>

            {this.state.showCompliant && this.renderCompliant()}
            {this.state.showMenstrual && this.renderMenstrual()}
            {carryOverInfo.keepable && this.renderAdjustment(carryOverInfo)}

            <button
              className="check-in-dialog-submit"
              onClick={this.handleSubmit}
              disabled={this.state.submitDisabled}
            >
              Edit Check-in
            </button>
          </div>
        </div>
      </Dialog>
    )
  }
}

export default EditWeighInModal
